import React from "react";
import { Building2, LayoutGrid } from "lucide-react";

const promptHints: Record<string, string> = {
    "Select a tab": "Choose a tab above to get started",
    "Select a client": "Choose a client from the dropdown above"
};

export const PmSelectPrompt = ({ message }: { message: string }): React.ReactElement => {
    const Icon = message.toLowerCase().includes("tab") ? LayoutGrid : Building2;
    const hint = promptHints[message];

    return (
        <div className="pm-select-prompt">
            <Icon className="pm-select-prompt-icon" aria-hidden="true" />
            <p className="pm-select-prompt-text">{message}</p>
            {hint ? <p className="pm-select-prompt-hint">{hint}</p> : null}
        </div>
    );
};
